import { mysiteContainer } from 'src/models'
// Pure utility (no React / redux)
const VIDEO_EXTENSIONS = [
  '.mp4',
  '.webm',
  '.mov',
  '.m4v',
  '.avi',
  '.mpeg',
  '.mpg',
  '.ogv',
  '.3gp',
]

const isVideoLike = (item, candidateUrl = '') => {
  const metaType =
    item && typeof item === 'object'
      ? `${item?.type || item?.mediaType || item?.mimeType || ''}`?.toLowerCase?.() ||
        ''
      : ''
  if (metaType?.includes?.('video')) return true

  const urlToCheck = candidateUrl?.toLowerCase?.() || ''
  return VIDEO_EXTENSIONS.some(ext => urlToCheck?.includes?.(ext))
}

export const getSelectedImageUrlForMysitePLP = (
  selectedCategories,
  product,
  defaultSkuId
) => {
  if (!selectedCategories || selectedCategories.length === 0 || !product) {
    return ''
  }
  const mysiteShopHeaderResponse = mysiteContainer?.mysiteShopHeaderResponse
  const categories = mysiteShopHeaderResponse?.market?.categories
  if (!Array.isArray(categories) || categories.length === 0) {
    return ''
  }
  const selectedCategory = categories.find(category =>
    selectedCategories.some(selected => selected?.categoryId === category?.id)
  )
  if (!selectedCategory) return ''
  const productIdentifier = product.identifier || ''
  const productSkuId = product.sku?.[0]?.identifier || ''

  if (!productIdentifier && !productSkuId) return ''

  const skus = selectedCategory.skus
  if (!Array.isArray(skus) || skus.length === 0) {
    return ''
  }
  if (defaultSkuId) {
    const skuMatch = skus.find(skuItem =>
      skuItem?.sku === defaultSkuId || skuItem?.globalId === defaultSkuId
    )
    if (skuMatch?.selectedImageUrl) return skuMatch.selectedImageUrl
  }
  const matchingSku = skus.find(skuItem => {
    if (!skuItem) return false
    return (
      skuItem.sku === productIdentifier ||
      skuItem.sku === productSkuId ||
      skuItem.productId === productIdentifier ||
      skuItem.globalId === productIdentifier ||
      skuItem.globalId === productSkuId
    )
  })
  return matchingSku?.selectedImageUrl || ''
}

export function extractCarouselImages(
  product = {},
  primaryImage = '',
  max = 5
) {
  const results = []
  if (primaryImage && !isVideoLike(primaryImage, primaryImage)) {
    results.push(primaryImage)
  }

  let raw = product?.properties?.productImages
  if (!raw) return results

  try {
    if (typeof raw === 'string') {
      raw = JSON.parse(raw)
    }
  } catch (_e) {
    return results
  }

  let extra = []
  if (Array.isArray(raw)) {
    extra = raw
      .map(item => {
        let candidate = ''

        if (typeof item === 'string') {
          candidate = item
        } else if (item && typeof item === 'object') {
          candidate = item?.url || item?.thumbnail || ''
        }

        if (isVideoLike(item, candidate)) return ''
        return candidate
      })
      .filter(Boolean)
  } else if (raw && typeof raw === 'object') {
    extra = Object.values(raw ?? {})
      .filter(v => typeof v === 'string')
      .filter(url => !isVideoLike(url, url))
  }

  for (const url of extra) {
    if (url && !results.includes(url)) {
      results.push(url)
      if (results.length >= max) break
    }
  }
  return results
}
